import gql from 'graphql-tag';

export default gql`
mutation changeAppPrice(
        $uuid: String!,
        $type: Int,
        $currency: String,
        $rentPrice: Float,
        $rentDays: Int,
        $buyPrice: Float
        ) {
    updateApps(input: {
        uuid: $uuid,
        type: $type,
        currency: $currency,
        rentPrice: $rentPrice,
        rentDays: $rentDays,
        buyPrice: $buyPrice
    }) {
        uuid
    }
}
`;
